import { useEffect, useContext, useState } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import esLocale from '@fullcalendar/core/locales/es';
import '../../styles/calendar.scss';
import momentPlugin from '@fullcalendar/moment';
import { diffDates } from '@fullcalendar/core/internal';
import {
  Heading,
  useToast,
  IconButton,
  Alert,
  AlertIcon,
  AlertTitle,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
  PopoverCloseButton,
} from '@chakra-ui/react';
import { FaInfoCircle } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const CalendarioExterno = ({
  user,
  enabled,
  setPasos,
  date,
  setDate,
  setDia,
}) => {

  const { t } = useTranslation();

  const today = new Date();
  const toast = useToast();

  const [calendarOptions, setCalendarOptions] = useState({
    plugins: [dayGridPlugin, interactionPlugin],
    locale: esLocale,
    initialView: 'dayGridMonth',
    validRange: {
      start: today,
    },
  });

  useEffect(() => {
    setCalendarOptions((prevOptions) => ({
      ...prevOptions,
      validRange: {
        start: today,
      },
    }));
  }, []);

  if (user.moroso) {
    return <div>{t('USER_DELINQUENT')}</div>;
  }

  // selecciona dia del calendario
  const handleSelect = (e) => {
    if (!enabled) return;
    if (today.getTime() > e.start.getTime()) return;
    const numDias = diffDates(e.start, e.end);
    setDia({ ...e });
    setPasos(2);
  };

  if (!enabled) return <div />;

  return (
    <div
      style={{
        opacity: enabled ? 1 : 0.5,
        cursor: enabled ? 'pointer' : 'not-allowed',
      }}
    >
      <div className="p-2">
        <Heading size={'sm'}>{t('SELECT_DATES_TO_RESERVE')}</Heading>{' '}
      </div>

      <div className="demo-app">
        <div className="demo-app-main">
          <FullCalendar
            {...calendarOptions}
            height={590}
            locale={esLocale}
            plugins={[
              dayGridPlugin,
              timeGridPlugin,
              interactionPlugin,
              momentPlugin,
            ]}
            headerToolbar={{
              left: 'prev,next today',
              center: 'title',
              right: 'dayGridMonth,timeGridWeek,timeGridDay',
            }}
            initialView="dayGridMonth"
            editable={true}
            selectable={true}
            selectMirror={true}
            dayMaxEvents={true}
            weekends={true}
            select={handleSelect}
            eventContent={renderEventContent} // custom render function
            datesSet={(args) => {
              setDate(
                today.getTime() > args.start.getTime()
                  ? {
                      ...date,
                      dateTo: args.endStr.split('T')[0],
                    }
                  : {
                      dateFrom: args.startStr.split('T')[0],
                      dateTo: args.endStr.split('T')[0],
                    }
              );
            }}
          />
          <Popover placement="right">
            <PopoverTrigger>
              <IconButton
                icon={<FaInfoCircle />}
                color={'black'}
                bg="rgb(239,184,16)"
                position="fixed"
                top="62px"
                right="45px"
                zIndex="999"
              ></IconButton>
            </PopoverTrigger>
            <PopoverContent border="1px solid rgb(239, 184, 16)">
              <PopoverArrow bg="rgb(239, 184, 16)" />
              <PopoverCloseButton />
              <PopoverBody>
                {t('RESERVATION_INSTRUCTIONS')}
              </PopoverBody>
            </PopoverContent>
          </Popover>
        </div>
      </div>
    </div>
  );
};

export default CalendarioExterno;

// a custom render function
function renderEventContent(eventInfo) {
  return (
    <>
      <b>{eventInfo.timeText}</b>
      <i>{eventInfo.event.title}</i>
    </>
  );
}
